import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {Helmet} from 'react-helmet';
import { useDispatch, useSelector } from "react-redux";
import AboutUs from "../aboutus";
import Faqs from "../faqs";
import Portfolios from "../portfolios";
import Features from "../features";
import Pricing from "../pricing";
import Services from "../services";
import Teams from "../teams";
import Testimonials from "../testimonials";
import Clients from "../clients";
import Certificate from "../Certificate";
import Contact from "../contact";

const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What kind of projects are included in your portfolio?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "My portfolio showcases a variety of projects including corporate websites, e-commerce stores, personal blogs, landing pages, and custom web applications built for clients across different industries."
      }
    },
    {
      "@type": "Question",
      "name": "Do you have experience with international clients?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I’ve worked with clients across the US, UK, Canada, Australia, and several other countries, delivering responsive and performance-optimized websites."
      }
    },
    {
      "@type": "Question",
      "name": "Are all the websites in your portfolio custom-designed?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most projects in my portfolio are fully custom-designed, while a few are built on premium templates that have been heavily customized to match client branding."
      }
    },
    {
      "@type": "Question",
      "name": "Do you showcase SEO results in your portfolio?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I often include screenshots or performance stats from tools like Google Search Console or Google Analytics when available, to demonstrate SEO growth and traffic improvements."
      }
    },
    {
      "@type": "Question",
      "name": "Can I request to see a live demo of any project?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, you can request a live demo or link for any publicly available project in my portfolio to explore it in real time."
      }
    },
    {
      "@type": "Question",
      "name": "Are the projects in your portfolio responsive and mobile-friendly?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. All portfolio projects are built with responsive design principles, ensuring they work smoothly across all devices."
      }
    },
    {
      "@type": "Question",
      "name": "Do you mention the technologies used in each portfolio item?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I list the major tools and technologies used for each project such as HTML5, CSS3, JavaScript, PHP, WordPress, React, and others."
      }
    },
    {
      "@type": "Question",
      "name": "Can I filter your portfolio by category?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, my portfolio page allows filtering by category such as Business, eCommerce, Personal, and Landing Pages for easier browsing."
      }
    },
    {
      "@type": "Question",
      "name": "Are client testimonials included in your portfolio?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, many of my portfolio projects include short testimonials or client feedback to showcase satisfaction and successful collaboration."
      }
    },
    {
      "@type": "Question",
      "name": "Can you create a similar website for my business?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. If you find a project in my portfolio that matches your vision, I can build a similar or improved version tailored to your business goals and brand."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
   <title>Portfolios - Website Design In Gurgaon</title>
  <meta name="description" content="Website designing company in gurgaon, Delhi, Noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India."/>
  <meta name="keywords" content="pankaj, pankj, web designers near me, website designer near me, web designing company in gurgaon, website designing company in gurgaon, website development company in gurgaon,freelance web designer, web design gurgaon, website design gurgaon, web design companies near me, web design company, website design company"/>
<meta property="og:title" content="Portfolios - website design in gurgaon | website development company in gurgaon" />
<meta property="og:description" content="Website design in gurgaon, Delhi, Noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<meta property="og:site_name" content="Portfolios - website design in gurgaon | website development company in gurgaon" />
<meta property="og:url" content="https://www.pankj.com/portfolios"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Portfolios - Website design in gurgaon | website development company in gurgaon" />
<meta name="twitter:description" content="website design in gurgaon, delhi, noida Your company’s website is the first line of inquiry for new customers, so why not Web design services from Me, one of Best Web Design and Development Companies in India." />
<link rel="canonical" href="https://www.pankj.com/portfolios" />
        </Helmet>
  <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer4.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
        <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
 <h1 className="multiple_effects" id="text3d">Portfolio</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="Website Maker In Gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   
    <main id="main">
    <Portfolios />
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
